// Exactly three surface roles (UI-LAW §7): `surface` (the workspace),
// `surfaceRaised` (hover fills, inputs, menus, detached panels), and
// `surfaceChrome` (the shell chrome only — sidebar + top bar, UI-LAW §8;
// never a feature surface). In dark the chrome sits a step BELOW the
// workspace so the viewport reads as an inset plane; in light it sits under
// the lighter workspace the same way.
export const markerColors = {
  light: {
    surface: "#f8f8f8",
    surfaceRaised: "#f1f1f1",
    surfaceChrome: "#f1f1f1",
    onSurface: "#181818",
    onSurfaceVariant: "#5f5f5f",
    outline: "#767676",
    outlineVariant: "#d9d9d9",
    primary: "#20583a",
    onPrimary: "#ffffff",
    primaryHover: "#17462d",
    error: "#b42318",
    onError: "#ffffff",
    errorSurface: "#fef3f2",
    onErrorSurface: "#7a271a",
    success: "#20583a",
    onSuccess: "#ffffff",
    chartNeutral1: "#5f5f5f",
    chartNeutral2: "#767676",
    chartNeutral3: "#a3a3a3",
    chartNeutral4: "#d9d9d9",
  },
  dark: {
    surface: "#121212",
    surfaceRaised: "#1a1a1a",
    surfaceChrome: "#0d0d0d",
    onSurface: "#efefef",
    onSurfaceVariant: "#bbbbbb",
    outline: "#8e8e8e",
    outlineVariant: "#323232",
    primary: "#99d4ad",
    onPrimary: "#082013",
    primaryHover: "#b5e8c4",
    error: "#ffb4ab",
    onError: "#5f1715",
    errorSurface: "#3a0a07",
    onErrorSurface: "#ffdeda",
    success: "#99d4ad",
    onSuccess: "#082013",
    chartNeutral1: "#bbbbbb",
    chartNeutral2: "#8e8e8e",
    chartNeutral3: "#5f5f5f",
    chartNeutral4: "#323232",
  },
} as const;

// Radius scales with the weight of the thing it bounds: chips (sm) < controls
// and small floating labels (md) < panel surfaces (lg). `none` is not a
// fallback — it is the deliberate value for structure (shell, tables, rows,
// dividers) and for any surface flush to a viewport edge. See UI-LAW §2.3.
export const markerRadii = {
  none: "0",
  sm: "2px",
  md: "4px",
  lg: "6px",
  full: "9999px",
} as const;

export const markerSpacing = {
  1: "4px",
  2: "8px",
  3: "12px",
  4: "16px",
  5: "20px",
  6: "24px",
  7: "28px",
  8: "32px",
  9: "36px",
  10: "40px",
  11: "44px",
  12: "48px",
  containerMax: "1280px",
} as const;

export const markerTypography = {
  headingLg: {
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "40px",
    letterSpacing: "0",
  },
  headingMd: {
    fontSize: "24px",
    fontWeight: 650,
    lineHeight: "32px",
    letterSpacing: "0",
  },
  headingSm: {
    fontSize: "18px",
    fontWeight: 650,
    lineHeight: "24px",
    letterSpacing: "0",
  },
  body: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0",
  },
  bodySm: {
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "18px",
  },
  label: {
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0",
  },
  caps: {
    fontSize: "11px",
    fontWeight: 700,
    lineHeight: "14px",
    letterSpacing: "0.08em",
  },
} as const;
